import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=2230b080&scoped=true&"
import script from "./CustomerList.vue?vue&type=script&lang=js&"
export * from "./CustomerList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=2230b080&prod&lang=less&"
import style1 from "./CustomerList.vue?vue&type=style&index=1&id=2230b080&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2230b080",
  null
  
)

export default component.exports